<div class="modal-header">
    <button class="btn btn-success" (click)="downloadData();">
        <span *ngIf="!buttonLoader" class="feather icon-download mr-1"></span>
        <span *ngIf="buttonLoader" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
        Download
    </button>
    <h5 class="modal-title font-weight-bold mt-2" id="modal-basic-title">{{'htmlText.deactivatedMerchants' | translate}}</h5>
    <button type="button" class="close mt-2" aria-label="Close" (click)="modal.close()">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="card-body logs">
    <div class="pb-md-3 table-responsive">
      <!-- {{recurringPaymentTxData | json}} -->
      <table class="table table-hover mb-0">
        <thead>
          <tr>
            <th class="pt-0 header_bolder text-left popup-headers" width="15%">ISO</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="20%">Merchant DBA</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="25%">Merchant Name</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="25%">Store DBA</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="25%">Store Name</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="20%">TPN</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="20%">Created On</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="20%">Deactivated On</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="20%">Last Transaction Date</th>
          </tr>
        </thead>                     
        <tbody>

          <tr *ngFor="let merchant of deactivatedMerchantList">
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{merchant.createdBy || 'NA'}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{merchant.dba || 'NA'}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{merchant.merchantName}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{merchant.tpnDba || 'NA'}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{merchant.storeName}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{(merchant.tpn) || 'NA'}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{(merchant.createdOn | dateTimePipe) || 'NA'}}</span>
            </td>
            <td class="text-left wht_space">
                <span placement="right" triggers="mouseenter:mouseleave">{{(merchant.deactivatedOn | dateTimePipe) || 'NA'}}</span>
            </td>
            <td class="text-left wht_space">
                <span placement="right" triggers="mouseenter:mouseleave">{{(merchant.lastTxDate | dateTimePipe) || 'NA'}}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
